// import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
// import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { AppBar, Autocomplete, Avatar, CircularProgress, Grid, Menu, MenuItem, Tab, Tabs, TextField, Theme, Toolbar, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as SlashcallLogoBlack } from '../../assets/slashcall/slashcall-logo-black.svg';
import { OZContext } from '../../contexts/OZContext';
import { clearSession, getUserName, preserveSlashcallSuperAdminPersonaBeforeSwitch } from '../../services/auth-service';
import { deleteValueInStorage } from '../../services/storage-service';
// import { getValueInStorage, setValueInStorage } from '../../services/storage-service';
// import {useMatch } from 'react-router-dom';
import jwt from 'jwt-decode';
import { stringAvatar } from "../../components/admin/common/Avatar";
import { useAgent } from '../../contexts/AgentContext';
import useDisableDevTools from '../../hooks/useDisableDevTools';
import { getUserLoggedIn, logOutAdmin } from '../../services/api-service';
import { syncLoggedInUserEmail } from '../../services/page-service';
import { LOCAL_STORAGE } from '../../utils/constants';
import { logoutAgentToolbar, checkRoles } from '../../utils/util';
import NotificationDrawer from '../NotificationDrawer/NotificationDrawer';
import '../OZToolbar/OZToolbar.css';

const useStyles = makeStyles((theme: Theme) => ({
	menuButton: {
		marginRight: theme.spacing(2)
	},
	tabs: {
		flexGrow: 1,
		padding: '0px 8px'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1 + ' !important',
		height: 74,
		background: 'white',
		boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06) !important',
		color: '#212121'
	},
	rightMenu: {
		display: 'flex'
	},
	selectComp: {
		// width: '99px',
		height: '35px',
		fontFamily: 'Roboto',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '14px',
		lineHeight: '16px',
		textAlign: 'center',
		color: '#212121',
		flex: 'none',
		order: '0',
		flexGrow: '0'
	}
}));

type Props = {
	selectedDashboard?: any;
	onSelectDashboard: any;
};

export default function OZToolbar({ onSelectDashboard }: Props) {
	const classes = useStyles();
	const navigate = useNavigate();
	const location = useLocation();
	const userName = getUserName();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [value, setValue] = React.useState(0);
	const [showTabs, setShowTabs] = React.useState(false);
	const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
	const { selectedDashboard, dashboardTabs, setDashboardTabs, clearContextData } = React.useContext(OZContext);
	const inAdmin = useLocation().pathname.includes('/admin')
	const inDataManagement = useLocation().pathname.includes('/data-management')
	const isLandingPage = useLocation().pathname.includes('/home')
	const isCommandCenter = useLocation().pathname.includes('/command-center')
	const [user, setUser] = React.useState<any>("");
	const [loading, setLoading] = React.useState(false);

	// Use the agent context
	const { isAgentLoggedIn, waitForAgentLogout } = useAgent();
	useDisableDevTools();

	React.useEffect(() => {
		let tempToken: any = "";

		try {
			tempToken = jwt(localStorage.getItem('token')!);
			try {
				if (tempToken) {
					setUser(tempToken);
				}
			} catch (nError) {
				// console.log("here error nError", nError);
				logout();
			}
		} catch (error) {
			// console.log("here error", error);
			logout();
		}
	}, [])

	const [hoveredtabId, setHoveredTabId] = React.useState(null);
	const [hoverClose, setHoverClose] = React.useState(false);

	// const handleUserChange = (event: SelectChangeEvent,) => {
	// 	localStorage.setItem('userId', event.target.value);
	// 	localStorage.setItem('selectedUser', event.target.value);
	// 	setSelectUser(event.target.value);
	// 	window.location.reload();
	// };
	const storedUserId = localStorage.getItem('userId');
	const storedSelectedUser = localStorage.getItem('selectedUser');

	const [selectUser, setSelectUser] = React.useState(
		storedSelectedUser ? storedSelectedUser : (storedUserId ? Number(storedUserId) : null)
	);


	// Use the storedSelectedUser as the default label to display
	const [selectedUserName, setSelectedUserName] = React.useState(storedSelectedUser || userName);
	console.log('selectUser', selectedUserName)

	React.useEffect(() => {
		const handleStorageChange = (event: StorageEvent) => {
			try {
				if (event.key === 'userId' || event.key === 'selectedUser') {
					window.location.reload();
				}
			} catch (error) {
				console.log('error in handleStorageChange', error);
			}
		};
		window.addEventListener('storage', handleStorageChange);
		return () => {
			window.removeEventListener('storage', handleStorageChange);
		};
	}, [userName]);

	const handleUserChange = async (event: React.SyntheticEvent, newValue: any) => {
		if (newValue) {
			preserveSlashcallSuperAdminPersonaBeforeSwitch(checkRoles('ROLE_SLASHCALL'));
			localStorage.setItem('userId', newValue.value);
			localStorage.setItem('selectedUser', newValue.label);
			if (newValue.userTZ) {
				localStorage.setItem('userTZ', newValue.userTZ);
			}
			setSelectUser(newValue.value);
			setSelectedUserName(newValue.label);
			try {
				const res = await getUserLoggedIn();
				syncLoggedInUserEmail(res);
			} catch (error) {
				console.log('error in syncEmailWithSelectedUser', error);
			}
			console.log('SelectedUSer', newValue.label)
			window.location.reload();
		}
	};



	// const userList = sessionStorage.getItem('userList') !== 'undefined' ? JSON.parse(sessionStorage.getItem('userList')!) : [];
	const usrLst = localStorage.getItem('userList');
	let userList: any[] = [];
	if (usrLst) {
		const parsedList = JSON.parse(usrLst);
		if (Object.keys(parsedList).length === 0) {
			userList = [];
		} else {
			userList = parsedList;
		}
	}
	const userSortedList: any[] | null = userList && Array.isArray(userList) ? userList?.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1) : null;

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		if (!hoverClose) {
			if (newValue === -1) return;
			if (newValue === 0) {
				navigate(`/preset`);
			}

			const newSelection = dashboardTabs.find((item: any) => item.id === newValue);
			onSelectDashboard(newSelection);
			setValue(newValue);
		}
	};

	const handleNotificationsDrawer = () => {
		setIsDrawerOpen(!isDrawerOpen);
	};

	const toggleNotificationDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const open = Boolean(anchorEl);

	function handleMenu(event: any) {
		setAnchorEl(event.currentTarget);
	}
	const onAddNewDashboard = () => {
		setValue(0);
		navigate(`/preset`);
	};
	function handleClose() {
		setAnchorEl(null);
	}

	function logout() {
		clearSession();
		clearContextData();
		navigate(`/login`);
	}

	const updateDashboardTabs = () => {
		if (!selectedDashboard?.id) return;
		const newDashboardTabs = [...dashboardTabs];
		const existingDashboard = newDashboardTabs.find((item) => item.id === selectedDashboard?.id);
		if (!existingDashboard) {
			newDashboardTabs.push(selectedDashboard);
			setDashboardTabs(newDashboardTabs);
		}
		setValue(selectedDashboard.id);

		// const newDashboardTabs = [...dashboardTabs];
		// // eslint-disable-next-line array-callback-return
		// const newDashboardTab = dashboardTabs.map((data: any) => {
		// 	if (data.id === selectedDashboard.id) {
		// 		return "dashboard already exists"
		// 	}
		// })
		// if (!newDashboardTab.includes("dashboard already exists") && Object.keys(selectedDashboard).length) {
		// 	newDashboardTabs.push(selectedDashboard)
		// }
		// setDashboardTabs(newDashboardTabs)
		// setValue(selectedDashboard.id);
	};

	React.useEffect(() => {
		updateDashboardTabs();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedDashboard]);

	React.useEffect(() => {
		if (location.pathname.includes('reports')) {
			setShowTabs(false);
		} else {
			if (location.pathname.includes('preset')) {
				setValue(0);
			}
			setShowTabs(true);
		}
	}, [location]);

	const handleTabClose = (id: number) => {
		const newDashboardTabs = dashboardTabs.filter((item: any) => item.id !== id);
		setDashboardTabs(newDashboardTabs);
		if (id === selectedDashboard.id) {
			setValue(0);
			navigate('/preset');
		}
		setHoverClose(false);
	};

	function handleSetPageTitle_FavIcon() {
		let url = window.location.href;
		// let url = "https://cxhub.engage.personacloud.net"
		// let url = "https://admin.engage.personacloud.net";
		const titleElement = document.getElementById('title-ozonetel');
		if (url.includes('cxhub')) {
			if (titleElement) {
				titleElement.innerText = 'CxHub';
			}
		} else if (url.includes('admin')) {
			if (titleElement) {
				titleElement.innerText = 'Admin';
			}
		}
		//code to change fav icon
		const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
		if (link) {
			let favIcon = localStorage.getItem('favIcon');

			if (favIcon !== null)
				link.href = favIcon
		}
	}

	function AdminHeaderLogo() {
		let domainNew = window.location.href;
		const isSlashcallDomain = window.location.href.includes('slashcall');
		let imageLink = `${process.env.PUBLIC_URL}/img/logo-1x.svg`;
		if (!domainNew.includes("ozonetel")) {
			handleSetPageTitle_FavIcon()
			let headerLogo = localStorage.getItem('headerLogo');

			if (headerLogo !== null)
				imageLink = headerLogo;
		}
		return (
			isSlashcallDomain
				? <SlashcallLogoBlack style={{ height: 40, width: 'auto' }} role="img" aria-label="Slashcall" />
				: <img src={imageLink} width="140" height='40' alt="header logo" ></img >
		)
	}

	async function handleClickLogout() {
		try {
			setLoading(true);
			const isAgentToolbarOpen = document.getElementById('OzonetelAgentToolbar') !== null;

			if (isAgentToolbarOpen && isAgentLoggedIn) {
				// Only wait for agent logout if agent is actually logged in
				console.log('Agent is logged in, waiting for logout...');
				logoutAgentToolbar();
				await waitForAgentLogout();
			} else {
				console.log('Agent not logged in or toolbar not open, skipping logout wait');
			}

			const response = await logOutAdmin();
			console.log('response in logout', response);
		} catch (error) {
			console.log('error in logout', error);
		} finally {
			logout();
			setLoading(false);
		}
	}

	return (
		<AppBar position="fixed" className={classes.appBar}>
			<Toolbar className={classes.appBar}>
				<div aria-label="logo" >
					<AdminHeaderLogo />
				</div>
				<div className={classes.tabs}>
					{(showTabs && !inAdmin && !inDataManagement && !isLandingPage && !isCommandCenter) && (
						<div className="tab-container">
							<Tabs className="oz-tabs" value={value} onChange={handleChange}>
								<Tab
									disableRipple
									className="oz-tab"
									onClick={() => {
										deleteValueInStorage(LOCAL_STORAGE.SELECTED_DASHBOARD);
										navigate(`/preset`);
									}}
									label="Dashboard"
									value={0}
								/>
								{dashboardTabs.map((tab: any) => (
									<Tab
										key={tab.id}
										disableRipple
										onMouseEnter={() => setHoveredTabId(tab.id)}
										icon={(hoveredtabId === tab.id) ? <CloseIcon onMouseEnter={() => setHoverClose(true)} onMouseLeave={() => setHoverClose(false)} onClick={() => handleTabClose(tab.id)} /> : ''}
										onMouseLeave={() => setHoveredTabId(null)}
										iconPosition="end"
										className="oz-tab"
										label={tab?.dashboard?.dashboardName}
										value={tab.id}
									/>
								))}
								<Tab disableRipple icon={<AddIcon onClick={onAddNewDashboard} />} className="no-padding" iconPosition="start" label={''} value={-1} />
								{/* <IconButton onClick={onAddNewDashboard}>
								<AddIcon />
							</IconButton> */}
							</Tabs>
						</div>
					)}
				</div>
				<div className={classes.rightMenu}>
					<Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="center" >
						{user?.isSupperAdmin ?
							<Grid item>
								{userSortedList && userSortedList?.length > 0 ? (
									<Autocomplete
										options={userSortedList}
										getOptionLabel={(option) => option.label}
										value={userSortedList.find((option) => (option.label === selectUser) || (option.value === selectUser)) || null}
										onChange={(event, newValue) => handleUserChange(event, newValue)}
										renderInput={(params) => (
											<TextField
												sx={{
													height: "44px",
													width: "200px",
													input: {
														"&::placeholder": {
															fontWeight: 400,
															fontSize: '14px',
															color: '#99A0A8 !important',
															opacity: 1
														},
													},
													'& .MuiOutlinedInput-root': {
														minHeight: "44px",
														fontSize: "14px",
														fontWeight: 400,
														color: params.inputProps.value === "" ? "#99A0A8" : "#212121",
														borderRadius: '8px',
														paddingLeft: '12px',
														paddingTop: '0px',
														paddingRight: '0px',
														paddingBottom: '0px'
														,
													}
												}}

												{...params} variant="outlined" value={selectedUserName} />
										)}

									/>
								) : (
									<label>{localStorage.getItem('userName')}</label>
								)}
							</Grid> : null
						}
						{/* {(showTabs && inAdmin) && 
                            <Grid item>
                                <img
                                    style={{ marginLeft: '5px',cursor: 'pointer' }}
                                    src={`${process.env.PUBLIC_URL}/icons/questionIcon.svg`}
                                    alt="edit"
                                    // onClick={(e) => handleQuestionIcon(e, label)}
                                >
                                </img>
                            </Grid>
                        } */}
						{/* <Grid item>
                            <NotificationsOutlinedIcon onClick={handleNotificationsDrawer} style={{ cursor: 'pointer',marginLeft: '5px' }} />
                        </Grid> */}
						<Grid item>
							<Avatar className='toolBarAvatar' onClick={handleMenu} {...stringAvatar(userName)}></Avatar>
							{/* <AccountCircleOutlinedIcon onClick={handleMenu} /> */}
						</Grid>
					</Grid>
					<NotificationDrawer isOpen={isDrawerOpen} toggleNotificationDrawer={toggleNotificationDrawer}></NotificationDrawer>
					<Menu
						id="menu-appbar"
						anchorEl={anchorEl}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'right'
						}}
						keepMounted
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right'
						}}
						open={open}
						onClose={handleClose}
					>
						<MenuItem className="title-case" onClick={handleClose}>
							User: <i>{userName}</i>
						</MenuItem>
						{/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
						<MenuItem disabled={loading} onClick={handleClickLogout}>{loading ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
							<Typography fontSize={12} color="text.secondary">Logging out...</Typography>
							<CircularProgress size={16} />
						</div> : 'Logout'}</MenuItem>
					</Menu>
				</div >
			</Toolbar >
		</AppBar >
	);
}
